import styles from '../styles/about.module.css';

const About = () => {

  return (
    <div className={styles.about}>
      <h2>About Me</h2>
      <h3>I love solving problems</h3>
      <p>I'm a Front-end Developer from Dublin. I recently graduated from Dublin City University with a Bachelor of Science in Enterprise Computing.</p>
      <p>I have spent the past months honing Front-end Development skills while creating web applications with real-world uses.</p>
      <p>I pride myself on my initiative, being a fast learner and a great communicator.</p>
    </div>
  )
}

export default About;
